/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FailItem
 */
export interface FailItem {
    /**
     * 用户ID
     * @type {number}
     * @memberof FailItem
     */
    userId?: number;
    /**
     * 会员名
     * @type {string}
     * @memberof FailItem
     */
    userName?: string;
    /**
     * 失败原因（当前语言文案）
     * @type {string}
     * @memberof FailItem
     */
    reason?: string;
}

/**
 * Check if a given object implements the FailItem interface.
 */
export function instanceOfFailItem(value: object): value is FailItem {
    return true;
}

export function FailItemFromJSON(json: any): FailItem {
    return FailItemFromJSONTyped(json, false);
}

export function FailItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): FailItem {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'] == null ? undefined : json['userId'],
        'userName': json['userName'] == null ? undefined : json['userName'],
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function FailItemToJSON(json: any): FailItem {
    return FailItemToJSONTyped(json, false);
}

export function FailItemToJSONTyped(value?: FailItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'userId': value['userId'],
        'userName': value['userName'],
        'reason': value['reason'],
    };
}

